export default __webpack_public_path__ + "static/media/SkyLogo.21b36a03.svg";